export var ILoginTypeEnum;
(function (ILoginTypeEnum) {
    ILoginTypeEnum["RM"] = "RM";
    ILoginTypeEnum["PARTNER"] = "PARTNER";
    ILoginTypeEnum["FRM"] = "FRM";
    ILoginTypeEnum["EMPLOYEE"] = "EMPLOYEE";
})(ILoginTypeEnum || (ILoginTypeEnum = {}));
export var ILoginScreenState;
(function (ILoginScreenState) {
    ILoginScreenState["LOGIN_SCREEN"] = "LOGIN";
    ILoginScreenState["OTP_SCREEN"] = "OTP";
    ILoginScreenState["SUCCESS"] = "SUCCESS";
})(ILoginScreenState || (ILoginScreenState = {}));
export var ECurrentLoginComponent;
(function (ECurrentLoginComponent) {
    ECurrentLoginComponent["RM_PARTNER_LOGIN_TABS"] = "RM_PARTNER_LOGIN_TABS";
    ECurrentLoginComponent["RESET_PASSWORD"] = "RESET_PASSWORD";
    ECurrentLoginComponent["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    ECurrentLoginComponent["FORGOT_LOGIN_ID"] = "FORGOT_LOGIN_ID";
    ECurrentLoginComponent["UNBLOCK_ACCOUNT"] = "UNBLOCK_ACCOUNT";
    ECurrentLoginComponent["FORGOT_LOGIN_ID_SUCCESS"] = "FORGOT_LOGIN_ID_SUCCESS";
})(ECurrentLoginComponent || (ECurrentLoginComponent = {}));
export var EResetPasswordFlow;
(function (EResetPasswordFlow) {
    EResetPasswordFlow["FORGOT_RESET_PASSWORD"] = "FORGOT_RESET_PASSWORD";
    EResetPasswordFlow["CHANGE_RESET_PASSWORD"] = "CHANGE_RESET_PASSWORD";
})(EResetPasswordFlow || (EResetPasswordFlow = {}));
